import { showNotification } from "@mantine/notifications";
import { AccountInfo } from "@azure/msal-browser";
import { Metier } from "../../../schemas-and-types/etablissement/etablissemen.schema";
import { getCancellationEmailSubject, getModificationEmailSubject, getRegistrationEmailSubject } from "./establishment.queries.i18n";
import i18n from "i18next";

  // * mantine notification system

export function showNotif(message: string) {
    showNotification({
      // title: "Default notification",
      message: message,
      // icon: <Fragment>{successIcon}</Fragment>,
      styles: (theme: any) => ({
        root: {
          backgroundColor: "#91BE1E",
        },
        title: { color: theme.white },
        description: { color: theme.white },
        closeButton: {
          color: theme.white,
          "&:hover": { backgroundColor: "#91BE1E" },
        },
      }),
    });
  }

  export function getUserInfo(accounts :AccountInfo[]){
    const userEmail = accounts[0].idTokenClaims?.email as string;
    const userName = accounts[0].name || "prenom nom";
    const names = userName.split(" ");
    const prenom = names[0];
    const nom = names[1];

    return {nom,prenom,userEmail}
  }

/**
 * Gets translated email subjects based on operation type
 */
export const getEmailSubjects = () => {
  return {
    registration: getRegistrationEmailSubject(),
    modification: getModificationEmailSubject(),
    cancellation: getCancellationEmailSubject()
  };
};

/**
 * Gets translated notification messages
 */
export const getNotificationMessages = () => {
  return {
    registrationSuccess: i18n.t('components.notifications.registrationSuccess'),
    updateSuccess: i18n.t('components.notifications.updateSuccess'),
    registrationCancelled: i18n.t('components.notifications.registrationCancelled')
  };
};